import { Action, MessageDescriptor } from '../types';
import { v4 as uuidv4 } from 'uuid';

export const addFlag = (
  type: 'success' | 'error',
  title: MessageDescriptor,
  description: MessageDescriptor
): Action => ({
  type: 'FLAG_ADD',
  flag: {
    type,
    title,
    description,
    id: uuidv4(),
  },
});

export const dismissFlag = (): Action => ({
  type: 'FLAG_DISMISS',
});
